import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const BatchRedirect = () => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const API_BATCH_URL = process.env.REACT_APP_API_BATCH_URL;

  useEffect(() => {
    const trimmedHash = hash ? hash.trim() : ""; // Prevent errors if hash is undefined
    console.log("Trimmed Hash value:", trimmedHash);

    // Validate hash format (must be exactly 10 alphanumeric characters)
    if (!/^[a-zA-Z0-9]{10}$/.test(trimmedHash)) {
      console.error("Invalid hash format");
      navigate("/notfound", { state: { message: "Invalid hash format. Please check the link." } });
      return;
    }

    const fetchBatch = async () => {
      try {
        const response = await fetch(`${API_BATCH_URL}/${trimmedHash}`, {
          headers: { Accept: "application/json" },
        });
        const data = await response.json();

        console.info("Batch API response:", data);

        if (!response.ok) {
          // If the response is not OK (e.g., 404), handle the error
          throw new Error(data.message || "Batch not found");
        }

        // Gesperrte Charge: Code ist nicht mehr gültig -> Sperr-Seite anzeigen
        // (leitet anschließend automatisch zur Hauptseite weiter).
        if (data.locked || data.status === "LOCKED") {
          navigate("/gesperrt", { state: { message: data.message } });
          return;
        }

        // If the response is successful (200 OK), navigate to the dashboard
        // with the message and the batch data from the backend
        if (data.redirectUrl) {
          console.log("Redirecting to:", data.redirectUrl);
          // If the backend provides a redirect URL, we navigate to it
          window.location.href = data.redirectUrl;  // This will handle the redirect on the client side
        } else {
          // If no redirect URL is provided, just show the batch details on the dashboard
          navigate("/dashboard", { state: { status: 200, message: data.message, data } });
        }
      } catch (error) {
        console.error("Error fetching batch:", error);
        // Redirect to Not Found page with dynamic error message from the backend
        navigate("/notfound", { state: { message: error.message || "Batch not found. Please check the batch ID." } });
      }
    };

    fetchBatch();
  }, [hash, navigate, API_BATCH_URL]);

  return <p>Loading batch information...</p>;
};

export default BatchRedirect;
